export const ACCENT_COLOR = "#016099";
